module.exports = __webpack_public_path__ + "img/icon-homepage-country-data-light-22.cb21c8b.svg";